import { useContext, useState, useEffect } from 'react';
import { Context } from '../../index';
import { Row, Col, Dropdown, Form, Button, Modal } from 'react-bootstrap';
import { createDetail, fetchBrands, fetchTypes } from '../../http/detailAPI';
import { observer } from 'mobx-react-lite';

const CreateDetail = observer(({ show, onHide }) => {
  const { detail } = useContext(Context);
  const [name, setName] = useState('');
  const [price, setPrice] = useState(0);
  const [file, setFile] = useState(null);
  const [info, setInfo] = useState([]);

  useEffect(() => {
    fetchTypes().then(data => detail.setTypes(data));
    fetchBrands().then(data => detail.setBrands(data));
  }, []);

  const addInfo = () => {
    setInfo([...info, { title: '', description: '', number: Date.now() }]);
  };

  const removeInfo = (number) => {
    setInfo(info.filter(i => i.number !== number));
  };

  const changeInfo = (key, value, number) => {
    setInfo(info.map(i => (i.number === number ? { ...i, [key]: value } : i)));
  };

  const selectFile = e => {
    setFile(e.target.files[0]);
  };

  const isValid = () => {
    if (!detail.selectedType.id) {
      alert('Пожалуйста, выберите тип');
      return false;
    }
    if (!detail.selectedBrand.id) {
      alert('Пожалуйста, выберите бренд');
      return false;
    }
    if (name.trim() === '') {
      alert('Пожалуйста, введите название');
      return false;
    }
    if (isNaN(price) || price < 0) {
      alert('Пожалуйста, введите корректную цену');
      return false;
    }
    return true;
  };

  const addDetail = () => {
    if (!isValid()) return;

    const formData = new FormData();
    formData.append('name', name);
    formData.append('price', `${price}`);
    if (file) {
      formData.append('img', file);
    }
    formData.append('brandId', detail.selectedBrand.id);
    formData.append('typeId', detail.selectedType.id);
    if (detail.selectedSubType.id) {
      formData.append('subTypeId', detail.selectedSubType.id);
    }
    formData.append('info', JSON.stringify(info));

    createDetail(formData)
      .then(() => {
        alert('Деталь добавлена');
      })
      .catch(error => {
        alert('Ошибка при добавлении детали: ' + error.message);
      });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Добавить устройство
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Dropdown className="mt-2 mb-2">
            <Dropdown.Toggle>{detail.selectedType.name || 'Выберите тип'}</Dropdown.Toggle>
            <Dropdown.Menu>
              {detail.types.map(type => (
                <Dropdown.Item
                  onClick={() => {
                    detail.setSelectedType(type);
                    detail.setSelectedSubType({});
                  }}
                  key={type.id}
                >
                  {type.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown className="mt-2 mb-2">
            <Dropdown.Toggle>
              {detail.selectedSubType.name || 'Выберите подтип (необязательно)'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {detail.selectedType.id ? (
                detail.subTypes.filter(subType => subType.typeId === detail.selectedType.id)
                  .length > 0 ? (
                  detail.subTypes
                    .filter(subType => subType.typeId === detail.selectedType.id)
                    .map(subType => (
                      <Dropdown.Item
                        onClick={() => detail.setSelectedSubType(subType)}
                        key={subType.id}
                      >
                        {subType.name}
                      </Dropdown.Item>
                    ))
                ) : (
                  <Dropdown.Item disabled>Подтипы отсутствуют</Dropdown.Item>
                )
              ) : (
                <Dropdown.Item disabled>Сначала выберите тип</Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown className="mt-2 mb-2">
            <Dropdown.Toggle>{detail.selectedBrand.name || 'Выберите бренд'}</Dropdown.Toggle>
            <Dropdown.Menu>
              {detail.brands.map(brand => (
                <Dropdown.Item
                  onClick={() => detail.setSelectedBrand(brand)}
                  key={brand.id}
                >
                  {brand.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Form.Control
            value={name}
            onChange={e => setName(e.target.value)}
            className="mt-3"
            placeholder="Введите название устройства"
          />
          <Form.Control
            value={price}
            onChange={e => setPrice(Number(e.target.value))}
            className="mt-3"
            placeholder="Введите стоимость устройства"
            type="number"
          />
          <Form.Control
            className="mt-3"
            type="file"
            onChange={selectFile}
          />
          <hr />
          <Button variant="outline-dark" onClick={addInfo}>
            Добавить новое свойство
          </Button>
          {info.map(i => (
            <Row className="mt-4" key={i.number}>
              <Col md={4}>
                <Form.Control
                  value={i.title}
                  onChange={e => changeInfo('title', e.target.value, i.number)}
                  placeholder="Введите название свойства"
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  value={i.description}
                  onChange={e => changeInfo('description', e.target.value, i.number)}
                  placeholder="Введите описание свойства"
                />
              </Col>
              <Col md={4}>
                <Button
                  onClick={() => removeInfo(i.number)}
                  variant="outline-danger"
                >
                  Удалить
                </Button>
              </Col>
            </Row>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={onHide}>Закрыть</Button>
        <Button variant="outline-success" onClick={addDetail}>Добавить</Button>
      </Modal.Footer>
    </Modal>
  );
});

export default CreateDetail;